import { TextField } from "@mui/material";
import { useState } from "react";
import { persianToEnglish, separate } from "../../scripts/functions";

const TextInput = ({
  number = false,
  onChange,
  onBlur,
  value,
  readOnly = false,
  disabled = false,
  label = "",
  smallerthan = null,
  errors = null,
  allowZero = false,
  noSepreate = false,
  err = false,
  price = false,
  noError = false,
  rows,
  InputProps = {},
  InputLabelProps = {},
  priceLabel = "ریال",
}) => {
  const [error, setError] = useState(null);
  return (
    <div className={` ${rows ? "textarea" : ""}`}>
      {/*  <span className="text-[#495057] text-xs font-medium mr-5 label">
        {label}
      </span> */}
      <div className="relative ">
        {" "}
        <TextField
          disabled={readOnly || disabled}
          multiline={rows}
          rows={rows}
          value={number && !noSepreate ? separate(value) : value}
          type="text"
          variant="outlined"
          sx={{ position: "relative" }}
          label={label}
          fullWidth={true}
          onChange={(e) => {
            if (value?.length === 0 && e.target.value === " ") {
              return;
            } else {
              if (number) {
                onChange(persianToEnglish(e.target.value));
                if (Number(e.target.value) > 0) {
                  setError(null);
                }

                if (smallerthan) {
                  if (Number(smallerthan) <= Number(e.target.value)) {
                    setError(errors);
                  }
                }
              } else {
                onChange(e.target.value);
              }
            }
          }}
          onInput={(e) => {
            if (number) {
              e.target.value = e.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1");
            }
          }}
          onBlur={(e) => {
            if (number) {
              if (Number(value) < 1 && !allowZero) {
                setError("عدد مثبت وارد کنید");
              } else if (Number(smallerthan) <= Number(value)) {
                setError(errors);
              } else {
                setError(null);
              }
            }
            if (onBlur) {
              onBlur(e.target.value);
            }
          }}
          InputProps={InputProps}
          /*    InputLabelProps={InputLabelProps} */
          error={Boolean(error || err)}
          helperText={
            err || error ? (
              <div className="text-left">
                {!noError && (
                  <> {err ? "این فیلد را به درستی پر کنید" : error}</>
                )}
              </div>
            ) : (
              false
            )
          }
        />
        {price && (
          <div className="absolute top-[1.3rem] left-5 font-bold text-xs">
            {priceLabel}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextInput;
